export enum uiModes {
  DARK = 'dark',
  LIGHT = 'light',
}
